import React from 'react';
import { formatBytes } from '../../../components/knowledge/KnowledgeUtils';

interface KnowledgeHeaderProps {
  totalDocuments: number;
  categoriesCount: number;
  totalStorage: number;
}

export function KnowledgeHeader({ totalDocuments, categoriesCount, totalStorage }: KnowledgeHeaderProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '20px', marginBottom: '24px' }}>
      
      {/* Left section */}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <h1 style={{ 
          fontFamily: "'Space Grotesk', sans-serif",
          color: 'var(--admin-card-text)', 
          fontSize: '37.9px', 
          fontWeight: 700, 
          margin: '0 0 6px', 
          letterSpacing: '-0.76px',
          lineHeight: '38px'
        }}>
          Knowledge Base
        </h1>
        <p style={{ 
          fontFamily: "'Inter', sans-serif",
          color: '#7C8891', 
          fontSize: '14px', 
          margin: 0, 
          fontWeight: 400,
          lineHeight: '20px',
          letterSpacing: '0'
        }}>
          Upload and manage your organization's sales documents.
        </p>
      </div>

      {/* Right section stats */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '40px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          <span style={{ color: 'var(--admin-card-subtext)', fontSize: '9px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '4px' }}>
            Total Documents
          </span>
          <span style={{ color: 'var(--admin-card-text)', fontSize: '24px', fontWeight: 800 }}>
            {totalDocuments}
          </span>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          <span style={{ color: 'var(--admin-card-subtext)', fontSize: '9px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '4px' }}>
            Categories
          </span>
          <span style={{ color: 'var(--admin-card-text)', fontSize: '24px', fontWeight: 800 }}>
            {categoriesCount}
          </span>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          <span style={{ color: 'var(--admin-card-subtext)', fontSize: '9px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '4px' }}>
            Storage Used
          </span>
          <span style={{ color: 'var(--admin-card-text)', fontSize: '24px', fontWeight: 800, display: 'flex', alignItems: 'baseline', gap: '4px' }}>
            {totalStorage === 0 ? (
              <>0 <span style={{ fontSize: '14px' }}>MB</span></>
            ) : (
              formatBytes(totalStorage).split(' ').map((part, i) => (
                <span key={i} style={i === 1 ? { fontSize: '14px' } : {}}>{part}</span>
              ))
            )}
          </span>
        </div>
      </div>
      
    </div>
  );
}
